import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import store from '@/store'
import router from './router'

//引入jquery
import $ from 'jquery'
window.jQuery = $;
window.$ = $;

//公共通用方法
import './utils'
//IDM配置合并
import './utils/idm_mix'

IDM.layer.run();
//把layer也设置为全局变量
window.layer = IDM.layer;

//设置VueRouter对象到IDM中
IDM.router.setVueRouter(router);

/**
 * 引入antd的抽屉层，用于控制中心（动态属性）的属性展示与设置
 * 但是预览页面多了100KB的js、32KB的css，所以如果不需要控制中心的时候建议在这里移除，在plugins/antd.js的注释放开，并且把preview.vue中的a-drawer注释
 */ 
import {
  Drawer,
  Button,
  Modal
} from 'idm-antv-ui';
import IDM from './utils'
Vue.use(Drawer);
Vue.use(Button);
Vue.use(Modal);

// import VConsole from 'vconsole';
// const vConsole = new VConsole();

Vue.config.devtools = true
Vue.prototype.IDM = IDM;
Vue.prototype.$http = IDM.http;
Vue.config.productionTip = false
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
